module.exports = __webpack_public_path__ + "static/media/Balzam_na_rty_CBD_retina.2dbfe7f8.jpg";